import { LanguageType } from "@/custom-types";
import { PriorityOption } from "@/graphql/generated";

export const priorityMapper = (type: PriorityOption, language: LanguageType) => {
  const texts = {
    en: {
      HIGH: 'High',
      MEDIUM: 'Medium',
      LOW: 'Low',
    },
    es: {
      HIGH: 'Alta',
      MEDIUM: 'Media',
      LOW: 'Baja',
    }
  }

  return texts[language][type]
}